export default __webpack_public_path__ + "static/media/mua-sam-1.56b92fbb.jpg";